import React from 'react';
import PropTypes from 'prop-types';

const MessageSquareTypingIcon = ({color = 'currentColor', ...props}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.83301 6.9082V6.83301M8.83301 6.9082V6.83301M12.833 6.9082V6.83301M8.57214 12.6591L4.39822 16.833V12.6591H2.83301C1.72844 12.6591 0.833008 11.7637 0.833008 10.6591V2.83301C0.833008 1.72844 1.72844 0.833008 2.83301 0.833008H14.833C15.9376 0.833008 16.833 1.72844 16.833 2.83301V10.6591C16.833 11.7637 15.9376 12.6591 14.833 12.6591H8.57214Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

MessageSquareTypingIcon.propTypes = {
  color: PropTypes.string,
};

export default MessageSquareTypingIcon;
